import React from 'react';

import { ButtonProps } from '@make-software/cspr-design';
import { Button } from '@block-explorer/ui';

import { useCustomHistory } from '../../router/navigation';
import { UNDELEGATE_STAKE_PATH } from '../../router/paths';
import { buildRouterPath } from '../../router/utils';
import { Validator } from '@block-explorer/entities';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface UndelegateButtonProps extends ButtonProps {
  validatorInfo: Validator | null;
  showShortLabel?: boolean;
}

export function UndelegateButton({
  validatorInfo: validator,
  showShortLabel,
  width,
  ...props
}: UndelegateButtonProps) {
  const { t } = useTranslation();
  const history = useCustomHistory();

  const activeAccountDelegations = useSelector(
    (state: RootState) => state.activeAccountDelegations.paginatedItems
  );

  const validatorPublicKey = validator?.key;

  if (validator == null || !validatorPublicKey) {
    return null;
  }

  const isDelegator = activeAccountDelegations?.some(
    (accountDelegation) =>
      accountDelegation.validator_public_key === validatorPublicKey
  );

  if (!isDelegator) {
    return null;
  }

  const label =
    showShortLabel || width === '100' ? t('Undelegate') : t('Undelegate Stake');

  return (
    <Button
      color="utility"
      width={width}
      onClick={(ev) => {
        ev.stopPropagation();
        history.push(
          buildRouterPath(UNDELEGATE_STAKE_PATH, undefined, {
            validatorPublicKey: validatorPublicKey,
          }),
          { allowedGoBack: true }
        );
      }}
      {...props}
    >
      {label}
    </Button>
  );
}

export default UndelegateButton;
